import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionDataSection,
  ReportSectionPlacementType,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { BaseAddressInfo } from './institution-header-configuration';

export class ContactHeaderConfiguration extends ReportSectionConfigurationBase {
  typeName = 'ContactHeaderConfiguration';
  readonly reportSection = ReportSection.None;
  nodataLocalizationKeyName = 'contactHeader';
  readonly name = 'contactHeader';
  readonly displayName = 'Header';
  override readonly placementType = ReportSectionPlacementType.Static;
  readonly applicableReportTypes = [ReportType.Contact];
  readonly reportViewModelSections = [ReportViewModelSection.InvestorProfile_ContactBaseInfo];
  minSize = 2;
  maxSize = 4;
  defaultSize = 4;
  readonly availableDataSections: ReportSectionDataSection[] = [
    {
      name: 'contactHeaderPrimaryIndicator',
      displayName: 'Primary Contact Indicator',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'contactHeaderRoleAndPrimaryInstitutionName',
      displayName: 'Job Title/Role and Primary Institution Name',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'contactHeaderEmail',
      displayName: 'Contact Email',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'contactHeaderPhoneNumber',
      displayName: 'Contact Phone Number',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'contactHeaderAddress',
      displayName: 'Contact Address',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'contactHeaderSustainabilityLeaf',
      displayName: 'Sustainability Leaf',
      isSelected: true,
      canConfigure: true
    }
  ];
}

export interface ContactHeaderData {
  [ReportViewModelSection.InvestorProfile_ContactBaseInfo]: ContactBaseInfo;
}

export interface ContactBaseInfo {
  // primaryCompanyLabel: {},
  primaryCompanyName: string;
  address: BaseAddressInfo;
  email: string;
  phone: string;
  jobTitle?: string;
  isPrimaryContact: boolean;
  isSustainable: boolean;
  profileId: string;
  name: string;
  language?: string;
}
